// extracted by extract-css-chunks-webpack-plugin
module.exports = {"outer":"LayoutShell__outer___2twy1","headerWrapper":"LayoutShell__headerWrapper___2ms-P","inner":"LayoutShell__inner___3BdKY","content":"LayoutShell__content___3gSli","sidebarLayout":"LayoutShell__sidebarLayout___1IWti","mainPanel":"LayoutShell__mainPanel___1rRCv","topBanner":"LayoutShell__topBanner___CA_pU"};
    if(module.hot) {
      // 1751719782659
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  